const actionBarStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  }
};

export default actionBarStyle;



// WEBPACK FOOTER //
// ./src/components/CRM/ActionBar/style.js